import * as Yup from 'yup';

export const PerformanceBenchmarkSchema = Yup.object().shape({
    benchmark: Yup.string().min(1, 'Benchmark is required').required('Benchmark is required'),
});

export type PerformanceBenchmarkDataType = Yup.InferType<typeof PerformanceBenchmarkSchema>;

type InitialValues = {
    benchmark: string;
};

export const PerformanceBenchmarkInitialValues: InitialValues = {
    benchmark: '',
};

export interface PerformanceBenchmarkInterface {
    benchmark: string;
}
